import React, { useState } from "react";
import "./ContactPage.css";
import toast from "react-hot-toast";
import { db } from "../../firebase/config"; 
import { collection, addDoc } from "firebase/firestore";
import { CircularProgress } from "@mui/material";
const ContactPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(db, "contacts"), {
        name,
        email,
        message,
        timestamp: new Date(),
      });
      toast.success(`Thank You ${name} for Contacting Us. We will Get Back to You Soon.`, {
        duration: 4000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
      setName("");
      setEmail("");
      setMessage("");
    } catch (error) {
      toast.error("Error submitting message. Please try again.", {
        duration: 2000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
      console.error("Firestore Error: ", error);
    }
    setLoading(false);
  };

  return (
    <>
      <div className="contactSection">
        <h2>Contact Us</h2>
        <div className="contactMap">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3324.4578723883187!2d73.13239317553904!3d33.56745917334331!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfa79d23b17ee5%3A0xefeaaf517cb20c80!2sPES%20SOLAR!5e0!3m2!1sen!2s!4v1740419258956!5m2!1sen!2s"
            width="800"
            height="600"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            title="uomomap"
          ></iframe>
        </div>
        <div className="contactInfo">
          <div className="contactAddress">
            <div className="address">
              <h3>Store in Islamabad</h3>
              <p>
              Office #2,2nd Floor, Ahmad Trade center Opposite Tahzeeb bakers main, PWD Housing Society Islamabad, 47000, Pakistan
                <br /> Pakistan
              </p>
              <p>
                admin@dummymail.com
                <br />
                +44 20 7123 4567
              </p>
            </div>
            {/* <div className="address">
              <h3>Store in India</h3>
              <p>
                A-791, A-791, Bandra Reclamation Rd, Mumbai
                <br /> Maharashtra
              </p>
              <p>
                contact@dummymail.com
                <br />
                +44 20 7123 4567
              </p>
            </div> */}
          </div>
          <div className="contactForm">
            <h3>Get In Touch</h3>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                value={name}
                placeholder="Name *"
                onChange={(e) => setName(e.target.value)}
                required
              />
              <input
                type="email"
                value={email}
                placeholder="Email address *"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <textarea
                rows={10}
                cols={40}
                placeholder="Your Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />
               <button type="submit" disabled={loading}>
               {loading ?  <CircularProgress size={24} color="inherit" /> : "Submit"}
             </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
